import React, { useState } from 'react';
import { mockCampsites } from '@/data/mockCampsites';
import type { Campsite } from '@/types/campsite';
import CampsiteDetail from './CampsiteDetail';

const ListMode: React.FC = () => {
  const [selectedCampsite, setSelectedCampsite] = useState<Campsite | null>(null);

  const getOccupancyColor = (percentage: number) => {
    if (percentage >= 90) return '#F53743';
    if (percentage >= 70) return '#FFB230';
    if (percentage >= 50) return '#FFB230';
    return '#719C40';
  };

  if (selectedCampsite) {
    return (
      <div className="flex-1">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-lg overflow-hidden">
          <CampsiteDetail
            campsite={selectedCampsite}
            onClose={() => setSelectedCampsite(null)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1">
      {/* Grid of Campsite Cards */}
      <div className="grid grid-cols-3 gap-6">
        {mockCampsites.map((campsite) => (
          <div
            key={campsite.id}
            onClick={() => setSelectedCampsite(campsite)}
            className="bg-white border border-gray-200 rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
          >
            {/* Image */}
            <div className="relative h-48 bg-gray-100">
              {campsite.images.length > 0 && (
                <img
                  src={campsite.images[0]}
                  alt={campsite.name}
                  className="w-full h-full object-cover"
                />
              )}
            </div>

            {/* Content */}
            <div className="p-4">
              {/* Title */}
              <h3
                className="mb-1"
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  fontWeight: 700,
                  lineHeight: '24px',
                  color: '#000000'
                }}
              >
                {campsite.name}
              </h3>

              {/* Code */}
              <p
                className="mb-3"
                style={{
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#667479'
                }}
              >
                Ex PSL/B/302
              </p>

              {/* Occupancy */}
              <div className="flex items-center justify-between">
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#000000'
                  }}
                >
                  Occupancy: {campsite.occupancy.current}/{campsite.occupancy.total}
                </span>
                <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: getOccupancyColor(campsite.occupancy.percentage) }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListMode;
